import { asyncLoader } from './AsyncLoader'
class CategoryListener {
	container

	setContainer (container) {
		this.container = container
		this.addListener()
	}

	addListener () {
		const options = this.container.querySelectorAll('.product-category')
		this._listener = this._listenToClick.bind(this);
		[...options].forEach(option => {
			option.addEventListener('click', this._listener)
		})
	}

	async _listenToClick (event) {
		const options = this.container.querySelectorAll('.product-category')
		options.forEach(options => options.classList.remove('active'))
		event.target.classList.add('active')
		asyncLoader.reset()
		asyncLoader.category = event.target.getAttribute('data-category')
		this.post = []
		asyncLoader.setStatus('IN_PROGRESS')
		await asyncLoader.loadMorePosts()
		asyncLoader.setStatus('DONE')
	}
}

const categoryListener = new CategoryListener()
export { CategoryListener, categoryListener }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_products_loader/core/CategoryListener.js